if (!customElements.get('discount-banner')) {
  customElements.define(
    'discount-banner',
    class DiscountBanner extends HTMLElement {
      connectedCallback() {
        if (this.isOutsideSchedule() && !window.Shopify?.designMode) {
          this.hidden = true;
          return;
        }

        this.button = this.querySelector('.discount-banner__button');
        this.regularPriceElement = this.querySelector('[data-discount-regular-price]');
        this.salePriceElement = this.querySelector('[data-discount-sale-price]');
        this.hintElement = this.querySelector('[data-discount-hint]');
        this.code = this.dataset.code;

        try {
          this.variantPrices = JSON.parse(this.querySelector('[data-discount-prices]').textContent);
        } catch {
          this.variantPrices = {};
        }

        this.button?.addEventListener('click', this.applyCode.bind(this));

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.section) return;
          const prices = this.variantPrices[event.data.variant?.id];
          if (!prices) return;
          if (this.regularPriceElement) this.regularPriceElement.textContent = prices.price;
          if (this.salePriceElement) this.salePriceElement.textContent = prices.sale;
        });

        if (this.readAppliedState()) this.setApplied();
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      isOutsideSchedule() {
        const now = Date.now() / 1000;
        const startsAt = Number(this.dataset.startsAt) || 0;
        const endsAt = Number(this.dataset.endsAt) || 0;
        return Boolean((startsAt && now < startsAt) || (endsAt && now > endsAt));
      }

      applyCode() {
        if (this.classList.contains('is-applied') || this.classList.contains('is-loading')) return;

        this.classList.add('is-loading');
        const url = `${window.Shopify?.routes?.root ?? '/'}discount/${encodeURIComponent(this.code)}`;

        fetch(url, { cache: 'no-store' })
          .then(() => {
            this.setApplied();
            this.saveAppliedState();
          })
          .catch(() => {
            // fetch blocked: fall back to the discount URL with a round-trip redirect
            window.location.href = `${url}?redirect=${encodeURIComponent(
              window.location.pathname + window.location.search
            )}`;
          })
          .finally(() => this.classList.remove('is-loading'));
      }

      setApplied() {
        this.classList.add('is-applied');
        if (this.hintElement && this.dataset.appliedText) {
          this.hintElement.textContent = this.dataset.appliedText;
        }
      }

      get storageKey() {
        return `discount-banner-applied:${this.code}`;
      }

      readAppliedState() {
        try {
          return sessionStorage.getItem(this.storageKey) === 'true';
        } catch {
          return false;
        }
      }

      saveAppliedState() {
        try {
          sessionStorage.setItem(this.storageKey, 'true');
        } catch {
          // private browsing: applied state just won't persist across pages
        }
      }
    }
  );
}
